import { useContext } from "react";

import { useFeatureGates } from "../../../cof-feature-gates/hooks";
import { CofConfigId, ExclusiveLensProgramStatus, type MyLensesLens } from "../../../gql-generated/types";
import { UserInfoContext } from "../../api/contexts";
import { calculateOwnerMismatch } from "../../utils/monetizationUtils";

interface UseMonetizationStateProps {
    lensForUpdate?: Pick<MyLensesLens, "distributionsList" | "lensCreatorPayoutEligibility">;
}

interface UseMonetizationStateReturn {
    isMyLensesCreatorPayoutEnabled: boolean;
    isUserEligibleForExclusiveLens: boolean;
    ownerMismatch: boolean;
    userLoading: boolean;
}

export const useMonetizationState = ({ lensForUpdate }: UseMonetizationStateProps): UseMonetizationStateReturn => {
    const userInfo = useContext(UserInfoContext);
    const { configs } = useFeatureGates();

    const isMyLensesCreatorPayoutEnabled = configs[CofConfigId.MyLensesCreatorPayout].enabled;
    const isUserEligibleForExclusiveLens =
        userInfo?.data?.getUserProfile.exclusiveLensProgramStatus ===
        ExclusiveLensProgramStatus.ExclusiveLensProgramStatusEligible;

    return {
        isMyLensesCreatorPayoutEnabled,
        isUserEligibleForExclusiveLens,
        ownerMismatch: calculateOwnerMismatch(lensForUpdate, userInfo?.data?.getUserProfile.userId),
        userLoading: !!userInfo?.loading,
    };
};
